"use client";

import React, { useEffect, useState } from "react";
import { motion, useAnimationControls } from "framer-motion";
import Image from "next/image";

const words = ["Trust", "Creativity", "Clarity", "Progress", "Growth"];
const initialY = 6;
const step = 20;
const sequence = [1, 0, 2, 3, 4];

function RightTopSection() {
  const controls = useAnimationControls();
  const [currentIndex, setCurrentIndex] = useState(sequence[0]);

  useEffect(() => {
    let isMounted = true;
    const animate = async () => {
      if (!isMounted) return;
      setCurrentIndex(sequence[0]);
      await controls.set({ y: `${initialY}%` });
      if (!isMounted) return;
      setCurrentIndex(sequence[1]);
      await controls.start({
        y: `${initialY + step}%`,
        transition: { duration: 0.5, ease: "easeOut" },
      });
      await new Promise((resolve) => setTimeout(resolve, 500));
      if (!isMounted) return;
      setCurrentIndex(sequence[2]);
      await controls.start({
        y: `${initialY - step}%`,
        transition: { duration: 0.5, ease: "easeOut" },
      });
      await new Promise((resolve) => setTimeout(resolve, 500));
      for (let i = 3; i < sequence.length; i++) {
        if (!isMounted) return;
        setCurrentIndex(sequence[i]);
        await controls.start({
          y: `${initialY - step * (i - 1)}%`,
          transition: { duration: 0.5, ease: "easeOut" },
        });
        await new Promise((resolve) => setTimeout(resolve, 500));
      }
      if (!isMounted) return;
      setCurrentIndex(sequence[0]);
      await controls.start({
        y: `${initialY}%`,
        transition: { duration: 1.5, ease: "easeInOut" },
      });

      if (!isMounted) return;
      setTimeout(animate, 500);
    };
    const delayTimeout = setTimeout(animate, 1000);

    return () => {
      isMounted = false;
      clearTimeout(delayTimeout);
    };
  }, [controls]);

  return (
    <div className="relative w-full sm:w-fit sm:px-0 px-4">
      <div className="relative w-full sm:w-[412px] h-[300px] sm:h-[390px] overflow-hidden rounded-[15px]">
        <Image
          src="/images/RightTopSection.svg"
          alt="Right Top Container"
          fill
          className="object-cover rounded-[15px]"
          priority
        />
      </div>
      <div className="absolute top-1/2 left-1/2 sm:w-[98.5%] w-[90%] -ml-[0.8px] -translate-x-1/2 -translate-y-1/2 rounded-[15px] border-[3px] border-white/20 border-b-white/5 border-r-white/5 bg-black/10 backdrop-blur-[27.5px] mx-4 sm:mx-0 h-24 sm:h-32" />

      <section className="absolute top-0 text-[55px] sm:text-[73px] font-light pl-10 text-white h-[300px] sm:h-[390px] overflow-hidden">
        <motion.section initial={{ y: `${initialY}%` }} animate={controls}>
          {words.map((word, index) => (
            <motion.div
              key={index}
              animate={{ fontWeight: currentIndex === index ? 400 : 300 }}
              transition={{ duration: 0.4 }}
              className={`transition-colors duration-300 bg-gradient-to-r from-[#82D5FF] to-[#A7E8E0] bg-clip-text text-transparent [background-position:-35.2%_0] [background-image:linear-gradient(99deg,_#82D5FF_-35.2%,_#A7E8E0_90.47%)] ${
                currentIndex === index ? "" : "text-white"
              }`}
            >
              {word}
            </motion.div>
          ))}
        </motion.section>
      </section>
    </div>
  );
}

export default RightTopSection;
